
import Component from "vue-class-component"
import {Prop} from "vue-property-decorator";
import Vue from 'vue';
import {CertificateStatus} from "@/api-client";
import {ls} from "@/CultureService";

@Component
export default class CertificateStatusBadge extends Vue {
  @Prop()
  status!: CertificateStatus;

  statusMap: { [id: string]: {cssClass: string, text:string}; } = {
    [CertificateStatus.Valid] : {cssClass: "badge badge-success", text: ls.Global_ValidityState_Valid},
    [CertificateStatus.Invalid] : {cssClass: "badge badge-danger", text: ls.Global_ValidityState_Invalid}
  };
}
